import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      createdAt: 1752072730381,
      error: {
        code: 0,
        label: '',
        message: '',
      },
      object: 'getall',
      success: true,
      data: {
        offer: {
          offer: [
            {
              _id: '68652fc440358850fbb81242',
              status: 'open',
              createdAt: '2025-07-02T13:10:28.135Z',
              updatedAt: '2025-07-02T13:10:28.135Z',
              borrowers: 1,
              agentName: 'שמוליק הסוכן',
              firstBorrower: {
                dob: '1998-12-31T22:00:00.000Z',
                idIssueDate: '1998-12-31T22:00:00.000Z',
                fullName: 'כגעכג',
                idNumber: '00018',
                phoneNumber: '0546303000',
                email: 'orenk@fintek.co.il',
                city: 'עגכעגכ',
                address: 'כגעכ',
              },
              hasSummeryFile: false,
            },
            {
              _id: '68652fca40358850fbb812c5',
              status: 'open',
              createdAt: '2025-07-02T13:10:34.315Z',
              updatedAt: '2025-07-02T13:10:34.315Z',
              borrowers: 1,
              agentName: 'שמוליק הסוכן',
              firstBorrower: {
                dob: '1998-12-31T22:00:00.000Z',
                idIssueDate: '1998-12-31T22:00:00.000Z',
                fullName: 'כגעכג',
                idNumber: '00018',
                phoneNumber: '0546303000',
                email: 'orenk@fintek.co.il',
                city: 'עגכעגכ',
                address: 'כגעכ',
              },
              hasSummeryFile: false,
            },
            {
              _id: '686a89dc59cd1351647f4992',
              status: 'open',
              createdAt: '2025-07-06T14:36:12.264Z',
              updatedAt: '2025-07-06T14:36:12.264Z',
              borrowers: 1,
              agentName: 'שמוליק הסוכן',
              firstBorrower: {
                dob: '1998-12-30T22:00:00.000Z',
                idIssueDate: '1998-12-30T22:00:00.000Z',
                fullName: 'כגעכג',
                idNumber: '00018',
                phoneNumber: '0546303000',
                email: 'orenk@fintek.co.il',
                city: 'עגכעגכ',
                address: 'כגעכ',
              },
              hasSummeryFile: false,
            },
            {
              _id: '686e2e60f52b29b1778a1e7e',
              status: 'open',
              createdAt: '2025-07-09T08:54:56.210Z',
              updatedAt: '2025-07-09T09:06:41.482Z',
              borrowers: 1,
              agentName: 'שמוליק הסוכן',
              firstBorrower: {
                dob: '1965-12-29T22:00:00.000Z',
                idIssueDate: '1998-12-29T22:00:00.000Z',
                fullName: 'בדעקה',
                idNumber: '00018',
                phoneNumber: '0546303000',
                email: 'fdfd@fdfd.co',
                city: 'כעגעכגע',
                address: 'עכגעכ',
              },
              hasSummeryFile: false,
            },
          ],
          count: 4,
        },
      },
    },
    error: {
      response: {
        createdAt: 1701115461239,
        object: 'login',
        success: false,
      },
      status: 500,
    },
  },
};

const gellAllOffersHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(1000);
  return HttpResponse.json(response, status);
};

export {
  gellAllOffersHandler,
};
